export default function calc() {

    const calcTransport = document.querySelector('.js-calc-transport');
    const calcAmount = document.querySelector('.js-calc-amount');
    const calcTrips = document.querySelector('.js-calc-trips');
    const calcResultValue = document.querySelector('.js-calc-result-value');

    if ( !calcTransport || !calcAmount || !calcTrips || !calcResultValue ) return;

    calcTransport.addEventListener('change', () => {
        calculation();
    });

    calcAmount.addEventListener('input', () => {
        calculation();
    });

    calcTrips.addEventListener('input', () => {
        calculation();
    });

    function calculation() {
        const transport = calcTransport.dataset.value;
        const amount = calcAmount.value;
        const trips = calcTrips.value;
        
        const result = transport * amount * trips;
        calcResultValue.textContent = result.toLocaleString('ru-RU') + ' ₽';
    }

    calculation();

}